import React from 'react'
import './CommonButton.css'
const CommonButton = ({ name, onClick, btnClass, maxWidth, type, disabled }) => {
    return (
        <button
            id='commonButton'
            className={btnClass}
            style={{ maxWidth: maxWidth ? maxWidth : '120px' }}
            onClick={onClick} 
            type={type}
            disabled={disabled ? disabled : false}
        >
            {name}
        </button>
    )
}

export default CommonButton
